import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Blinders animation
gsap.to(".blinder-left .blinder-fill", {height: 0, duration: "1.5", stagger: -.15, ease: "power3.inOut", onComplete: hideBlinders});
gsap.to(".blinder-right .blinder-fill", {height: 0, duration: "1.5", stagger: .15, ease: "power3.inOut", onComplete: hideBlinders});
let theBlinders = document.querySelector(".blinders-container");
function hideBlinders() {
    theBlinders.style.display="none";
}